export const projectManagementGettingStartedArticle = {
  title: 'Project Management Hub: Getting Started',
  slug: 'project-management-getting-started',
  content: `Project Management Hub: Getting Started

Plan projects, manage tasks, and monitor delivery.

1) Open Project Management
- Go to /project-management.
- Tabs use URL hashes (for example #projects).

2) Key tabs
- Projects, My Tasks, Tasks, Portfolios, Workload, Goals.
- Team, Timeline, Automations, and Reports are also available.

3) Navigate with hash links
- The hub reads the URL hash to pick the active tab.

Tips
- Workload and Automations are marked as team-plan features in the UI.
`,
};
